import React, { Fragment } from 'react';
import { ReactComponent as Header } from '../../img/online-page.svg';
import { ReactComponent as Tools } from '../../img/mind-map.svg';
import { ReactComponent as WhoAmI } from '../../img/who.svg';

const About = () => {
  return (
    <Fragment>
      <section id='create-section' className='py-5'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6 order-1'>
              <Header className='img-fluid mb-3' />
            </div>
            <div className='col-md-6 order-2'>
              <h3>About This WebSite</h3>
              <p>
                The content of this site includes the search for Github users,
                as it enables you to quickly search for the person you want with
                the possibility of seeing a lot of information on it, and you
                can even link you to its official page on the site
              </p>
              <p>
                The content of this site has been developed Programmer Begin in
                the design, excuse us for the many mistakes and also was
                developed through many tools so you can learn more about that
                below
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id='create-head-section'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6 order-2'>
              <Tools className='img-fluid mb-3' />
            </div>
            <div className='col-md-6 py-5 order-1'>
              <h1 className='display-4'>Tools</h1>
              <p className='lead'>
                Bootstrap and React were used mainly in this simple project as
                well as in some synergies from CSS
              </p>
              <div className='row'>
                <div className='col-6'>
                  <a href='https://fr.reactjs.org/' className='btn btn-dark'>
                    <i className='fab fa-react' style={iconStyle}></i>React
                  </a>
                </div>
                <div className='col-6'>
                  <a href='https://getbootstrap.com/' className='btn btn-dark'>
                    <i className='fab fa-bootstrap' style={iconStyle}></i>
                    Bootstrap
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id='create-section' className='py-5'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6 order-1'>
              <WhoAmI className='img-fluid mb-3' />
            </div>
            <div className='col-md-6 order-2'>
              <h3>Who am I?</h3>
              <p>
                Hello! My name is Zighed this is first name, I'm full stack web
                developer use NodeJs/JavaScript have some experience and this
                site is first project in Desgin, I used som skills Bootstrap,
                React and Css for build all that, I hope is good and followe me
                in my social media above this article, if you want work with me
                you can contacte in my email.
              </p>
              <div className='row' style={{ marginTop: '200px' }}>
                <div className='col-4'>
                  <a
                    href='https://www.facebook.com/mohammed.lamine.796'
                    className='btn btn-dark'
                    style={linkStyle}
                  >
                    <i className='fab fa-facebook' style={iconStyle}></i>
                    Facebook
                  </a>
                </div>
                <div className='col-4'>
                  <a
                    href='https://www.instagram.com/z_mohammed_elamine/'
                    className='btn btn-dark'
                    style={linkStyle}
                  >
                    <i className='fab fa-linkedin' style={iconStyle}></i>
                    LinkedIn
                  </a>
                </div>
                <div className='col-4'>
                  <a
                    href='https://www.linkedin.com/in/zighed-mohammed-729706198/'
                    className='btn btn-dark'
                    style={linkStyle}
                  >
                    <i className='fab fa-instagram' style={iconStyle}></i>
                    Instgram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

const iconStyle = {
  marginRight: '5px',
  fontSize: '16px'
};

const linkStyle = {
  width: '100%'
};

export default About;
